import { domContentLoaded } from '@flowio/browser-helpers';
import loadPolyfills from './load-polyfills';

loadPolyfills(() => {
  window.Flow = require('./entry'); // eslint-disable-line global-require

  if (process.env.FLOW_JS_MANUAL_INIT) {
    window.Flow.manualInit = true;
  }

  domContentLoaded(() => {
    window.Flow.init({ initByDomContentLoaded: true });
  });
});



// WEBPACK FOOTER //
// ./static/js/v0/index.js